import { Consts } from '@/helpers/consts'

export default {
  install(Vue) {
    Vue.prototype.$consts = (key) => Consts[key]
  }
}
